export const borderWidths = {
    xs: { value: "0.5px" },
    sm: { value: "1px" },
    md: { value: "2px" },
    lg: { value: "4px" },
    xl: { value: "8px" }
};
